import React, { Component } from 'react'
import { Layout } from 'antd'

import OutsideHeader from '../../components/outside-common/outsideHeader'
import OutsideContent from '../../components/outside-common/outsideContent'
import OutsideFooter from '../../components/outside-common/outsideFooter'

import './outside.css'

const { Header, Content, Footer } = Layout

export default class Outside extends Component {
    render() {
        return (
            <Layout className="outside">
                <Header>
                    <OutsideHeader />
                </Header>
                <Content>
                    <OutsideContent />
                </Content>
                <Footer>
                    <OutsideFooter />
                </Footer>
            </Layout>
        )
    }
}